<template>
  <div class="mx-auto max-w-screen-lg">
    <domain-validator :allowed-domains="params?.domains">
      <embed-wrapper
        v-if="params"
        :id="theme"
        :class="['w-full p-4']"
        :params="params" />

      <div
        v-else-if="isDev"
        class="py-8 text-center">
        <p class="text-red-500">No configuration params provided.</p>

        <p>
          Go to the
          <a
            href="/creator.html"
            class="text-blue-500"
            >embed creator</a
          >
          to create an embed.
        </p>
      </div>
    </domain-validator>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import AES from "crypto-js/aes";
import ENC from "crypto-js/enc-utf8";

import DomainValidator from "@/components/DomainValidator";
import EmbedWrapper from "@/components/EmbedWrapper";
import { storageKey } from "@/config";

const components = {
  DomainValidator,
  EmbedWrapper,
};

const computed = {
  ...mapGetters(["theme"]),
  isDev() {
    return process.env.NODE_ENV === "development";
  },
};

const methods = {
  ...mapActions(["setTheme"]),
  setLocale() {
    if (this.params?.spanish && this.$i18n.locale !== "es") {
      this.$i18n.locale = "es";
    } else {
      this.$i18n.locale = "en";
    }
  },
  isTheme(theme) {
    return Boolean(
      this.params.clients.find((c) => {
        return c.theme === theme;
      })
    );
  },
};

export default {
  name: "Home",
  components,
  data: () => ({
    params: null,
    customThemes: [
      {
        name: "business-insider",
        checks: ["businessinsider", "insider"],
      },
      {
        name: "peoples-pundit-daily",
        checks: ["peoplespunditdaily"],
      },
      {
        name: "the-hill-editorial",
        checks: ["thehill"],
      },
      {
        name: "ddhq-dark",
        checks: [],
      },
    ],
  }),
  computed,
  beforeMount() {
    let encodedQueryString = window.location.search;
    let query = {};
    if (encodedQueryString) {
      encodedQueryString = encodedQueryString.substring(1);
      const bytes = AES.decrypt(encodedQueryString, "secret").toString(ENC);
      query = JSON.parse(bytes);
    }
    if (Object.keys(query).length > 0) {
      this.params = query;
      for (const prop in this.params) {
        if (this.params[prop] === "null") this.params[prop] = null;
        if (this.params[prop] === "true") this.params[prop] = true;
        if (this.params[prop] === "false") this.params[prop] = false;
      }
    }
    this.setLocale();

    for (var key in localStorage) {
      if (!key.includes(storageKey) && key !== storageKey) {
        localStorage.removeItem(key);
      }
    }

    this.customThemes.forEach((theme) => {
      if (this.isTheme("ddhq-dark")) {
        this.setTheme("ddhq-dark");

        if (process.env.NODE_ENV === "development") {
          document.body.style.backgroundColor = "#000";
        }
      } else if (this.isTheme("the-hill")) {
        this.setTheme("the-hill");
      } else if (this.isTheme("the-hill-editorial")) {
        this.setTheme("the-hill-editorial");
      } else if (theme.checks.some((t) => document.referrer.includes(t))) {
        this.setTheme(theme.name);
      } else if (this.params.domains.includes("peoplespunditdaily.com")) {
        this.setTheme("peoples-pundit-daily");
      }
    });
  },
  methods,
};
</script>
